// extracted by mini-css-extract-plugin
module.exports = {"loginModalStyle":"style_loginModalStyle__WKRQM"};